import React from 'react';
import * as asyncLoad from '../util/asyncLoad';
import { workflowPublicFiles } from '../constants/fileConfig';
import Loading from './Loading';

export default class RemindSet extends React.Component{

    constructor(){
        super();
        this.state = {hasLoad: false};
    }

    componentDidMount(){
        const init = () =>{
            const { RemindSetStore } = window.weaWorkflowPublic;
            const store = new RemindSetStore();
            this.setState({hasLoad: true,store:store});
        }
        asyncLoad.asyncLoadModule('workflowPublic', workflowPublicFiles, init);
    }
    render(){
        const { hasLoad ,store} = this.state;
        if(hasLoad){
            const { RemindSet } = window.weaWorkflowPublic;
            const { requestId,workflowId,submitType,callBackActions } = this.props;
            store.setParams({requestId : requestId,workflowId : workflowId,submitType:submitType});
            store.setCallBackActions(callBackActions);
            return (<RemindSet ecId={`${this && this.props && this.props.ecId || ''}_RemindSet@v5c2sk`} store={store} />);
        }else{
            return (<Loading ecId={`${this && this.props && this.props.ecId || ''}_Loading@j2a95y`} />);
        }
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/asyncComps/RemindSet.js